/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Members } from '../../models/members';

export interface GetMemberApiV2MembersOrgGet$Params {
  org: string;
}

export function getMemberApiV2MembersOrgGet(http: HttpClient, rootUrl: string, params: GetMemberApiV2MembersOrgGet$Params, context?: HttpContext): Observable<StrictHttpResponse<(Members | {
})>> {
  const rb = new RequestBuilder(rootUrl, getMemberApiV2MembersOrgGet.PATH, 'get');
  if (params) {
    rb.path('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(Members | {
      })>;
    })
  );
}

getMemberApiV2MembersOrgGet.PATH = '/api/v2/members/{org}';
